export type AdGroupToggleState = 'ENABLED' | 'PAUSED';

export type AdGroupActiveSwitchMode =
  | { kind: 'toggle'; checked: boolean; targetState: AdGroupToggleState }
  | { kind: 'unsupported'; label: string };

/** Map Amazon ad-group state to Active switch UI. Unknown states are never shown as paused. */
export function resolveAdGroupActiveSwitchMode(state: string | null | undefined): AdGroupActiveSwitchMode {
  const normalized = (state ?? '').trim().toUpperCase();
  if (normalized === 'ENABLED') {
    return { kind: 'toggle', checked: true, targetState: 'PAUSED' };
  }
  if (normalized === 'PAUSED') {
    return { kind: 'toggle', checked: false, targetState: 'ENABLED' };
  }
  if (!normalized || normalized === 'UNKNOWN' || normalized === '-') {
    return { kind: 'unsupported', label: 'Unavailable' };
  }
  return { kind: 'unsupported', label: normalized };
}

export function adGroupActiveAriaLabel(adGroupName: string, mode: AdGroupActiveSwitchMode): string {
  const name = adGroupName.trim() || 'Ad group';
  if (mode.kind === 'unsupported') {
    return `${name}: active status ${mode.label.toLowerCase()}`;
  }
  return mode.checked ? `${name}: active` : `${name}: paused`;
}
